(function () {
  if (window.kwoTabReviewsLoaded) return;
  window.kwoTabReviewsLoaded = true;

  var MAX_REVIEWS = 3;
  var userTouched = false;

  function readReviews() {
    var root = document.querySelector('.valued-product-reviews');
    if (!root) return null;
    var starPath = root.querySelector('.valued-star-rating-icon path');
    var items = [].slice.call(root.querySelectorAll('li.valued-review-content')).map(function (li) {
      var name = li.querySelector('strong');
      var date = li.querySelector('.valued-help-text');
      var body = li.querySelector('.valued-review-body');
      return {
        stars: li.querySelectorAll('.valued-star-rating svg').length,
        name: name ? name.textContent.trim() : '',
        date: date ? date.textContent.trim() : '',
        body: body ? body.textContent.trim() : ''
      };
    }).filter(function (r) { return r.body; });
    if (!items.length) return null;
    var count = root.querySelector('.valued-rating-count');
    return {
      items: items,
      total: count ? parseInt(count.textContent.replace(/\D/g, ''), 10) || items.length : items.length,
      starD: starPath ? starPath.getAttribute('d') : ''
    };
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function stars(count, d) {
    var wrap = el('div', 'review-stars');
    wrap.setAttribute('aria-label', count + ' van 5 sterren');
    for (var i = 0; i < count; i++) {
      var s = el('span', 'review-star');
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor"><path d="' + d + '"></path></svg>';
      wrap.appendChild(s);
    }
    return wrap;
  }

  function initials(name) {
    var parts = name.split(/\s+/).filter(Boolean);
    if (!parts.length) return '';
    var a = parts[0].charAt(0);
    var b = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (a + b).toUpperCase();
  }

  function render(sr, panel, data) {
    var allInTab = !!document.querySelector('.kwo-polish-flag');
    var stack = el('div', 'panel-stack');
    stack.setAttribute('data-kwo-reviews', '');
    var list = allInTab ? data.items : data.items.slice(0, MAX_REVIEWS);
    list.forEach(function (r, i) {
      var card = el('div', 'kwo-review');
      if (allInTab && i >= MAX_REVIEWS) {
        card.setAttribute('data-kwo-extra', '');
        card.hidden = true;
      }
      if (r.stars) card.appendChild(stars(r.stars, data.starD));
      var content = el('div', 'panel-content');
      content.appendChild(el('p', '', r.body));
      card.appendChild(content);
      var footer = el('div', 'review-footer');
      var avatar = el('div', 'reviewer-image-wrap reviewer-image-wrap--initials');
      avatar.appendChild(el('span', 'reviewer-initials', initials(r.name)));
      footer.appendChild(avatar);
      var copy = el('div', 'reviewer-copy');
      var top = el('div', 'reviewer-top');
      top.appendChild(el('div', 'reviewer-name', r.name));
      copy.appendChild(top);
      var meta = el('div', 'reviewer-meta');
      meta.appendChild(el('span', 'reviewer-date', r.date));
      copy.appendChild(meta);
      footer.appendChild(copy);
      card.appendChild(footer);
      stack.appendChild(card);
    });
    if (allInTab) {
      if (list.length > MAX_REVIEWS) {
        var openLabel = data.total <= list.length ? 'Toon alle ' + list.length + ' reviews' : 'Toon meer reviews';
        var toggle = el('button', 'kwo-reviews-more', openLabel);
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          stack.querySelectorAll('[data-kwo-extra]').forEach(function (c) { c.hidden = open; });
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          toggle.textContent = open ? openLabel : 'Toon minder reviews';
        });
        stack.appendChild(toggle);
      }
    } else {
      var target = document.getElementById('product-reviews-block');
      var more = el('a', 'kwo-reviews-more', 'Bekijk alle ' + data.total + ' reviews op WebwinkelKeur');
      more.href = '#product-reviews-block';
      more.addEventListener('click', function (e) {
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      if (target) stack.appendChild(more);
    }
    panel.textContent = '';
    panel.appendChild(stack);
  }

  function ensureStyle(sr) {
    if (sr.querySelector('style[data-kwo-reviews]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-kwo-reviews', '');
    st.textContent =
      '.kwo-review{display:flex;flex-direction:column;gap:12px}' +
      '.kwo-review[hidden]{display:none}' +
      '.kwo-review + .kwo-review{padding-top:18px;border-top:1px solid var(--divider-color)}' +
      '.kwo-reviews-more{align-self:flex-start;color:var(--text-color);font-family:inherit;font-size:var(--content-text-size-desktop);text-decoration:underline;text-underline-offset:3px;cursor:pointer;background:none;border:0;padding:0}' +
      '.kwo-reviews-more:hover{color:var(--muted-text-color)}';
    sr.appendChild(st);
  }

  function ensurePolish(sr) {
    if (!document.querySelector('.kwo-polish-flag')) return;
    if (sr.querySelector('style[data-kwo-polish]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-kwo-polish', '');
    st.textContent = '.body{--radius:12px !important;--border-color:#e0dddd !important;}';
    sr.appendChild(st);
  }

  function basicDecide(sr) {
    var flag = document.querySelector('.kwo-basic-flag');
    if (!flag) return;
    var first = sr.querySelector('[data-tab-key="first"]');
    var second = sr.querySelector('[data-tab-key="second"]');
    if (!first || !second) return;
    if (!flag.hasAttribute('data-init')) {
      flag.setAttribute('data-init', '');
      sr.addEventListener('click', function (e) {
        if (e.isTrusted && e.target.closest && e.target.closest('[data-tab-key]')) userTouched = true;
      });
      first.style.display = 'none';
      if (first.getAttribute('aria-selected') === 'true') second.click();
      flag.setAttribute('data-ready', '');
    }
    if (first.style.display === 'none' && readReviews()) {
      first.style.display = '';
      if (!userTouched) first.click();
    }
  }

  function update(sr) {
    basicDecide(sr);
    var first = sr.querySelector('[data-tab-key="first"]');
    var panel = sr.querySelector('.tabs-panel');
    if (!first || !panel) return;
    if (first.getAttribute('aria-selected') !== 'true') return;
    if (panel.querySelector('[data-kwo-reviews]')) return;
    var data = readReviews();
    if (!data) return;
    ensureStyle(sr);
    render(sr, panel, data);
  }

  function attach() {
    var tabs = document.querySelector('section-store--tabs-block');
    if (!tabs || !tabs.shadowRoot) return false;
    var sr = tabs.shadowRoot;
    ensurePolish(sr);
    new MutationObserver(function () { update(sr); }).observe(sr, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });
    update(sr);
    [200, 600, 1200, 2500, 4500].forEach(function (ms) {
      setTimeout(function () { ensurePolish(sr); update(sr); }, ms);
    });
    if (document.querySelector('.kwo-basic-flag')) {
      var n = 0;
      var poll = setInterval(function () {
        update(sr);
        if (++n > 24) clearInterval(poll);
      }, 500);
    }
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (attach() || ++tries > 40) clearInterval(timer);
  }, 250);

  setTimeout(function () {
    var f = document.querySelector('.kwo-basic-flag');
    if (f) f.setAttribute('data-ready', '');
  }, 4000);

  function compactStaffel() {
    if (!document.querySelector('.kwo-polish-flag')) return true;
    var b = document.querySelector('section-store--bundle-block');
    if (!b) return false;
    var sr = b.shadowRoot;
    if (!sr || !sr.querySelector('.body')) return false;
    if (!sr.querySelector('style[data-kwo-compact]')) {
      var st = document.createElement('style');
      st.setAttribute('data-kwo-compact', '');
      st.textContent = '.body{--option-padding-y:7px !important;--option-padding-x:12px !important;--option-title-font-size:16px !important;--option-price-font-size:16px !important;--option-original-price-font-size:12px !important;--option-subtitle-font-size:12px !important;--option-gap:6px !important;--option-indicator-size:16px !important;}';
      sr.appendChild(st);
    }
    return true;
  }
  var cTries = 0;
  var cTimer = setInterval(function () {
    if (compactStaffel() || ++cTries > 40) clearInterval(cTimer);
  }, 250);
})();